import React from 'react';

const CustomSelectField = ({label, placeholder, name, onChange, value, error, onBlur, touched, children, disabled= false}) => {
  return (
    <div className="form-group" >
        <label className="form-label">
          {label}
        </label>
        <select
          required
          className={`form-control ${touched && error ? 'is-invalid' : ''}`}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          disabled={disabled}
        > 
          <option value="">Select Here</option>
          {children}
        </select>
        {touched && error && (
        <div class="invalid-feedback">
          {error}
        </div>
        )}
    </div>
  )
}

export default CustomSelectField